import { Action } from 'redux';

import { RenameContent } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface RenameContentAction extends Action {
  content: IContentInfo;
}

export function renameContent(content: IContentInfo): RenameContentAction {
  return {
    type: RenameContent,
    content
  };
}

export const isRenameContentAction = isActionFactory<RenameContentAction>(RenameContent);
